( function( $ ) {
	'use strict';

	$( function() {
		const $carousel = $( '.js-story-carousel' );
		const $prevButton = $( '.js-story-carousel-button-prev' );
		const $nextButton = $( '.js-story-carousel-button-next' );
		const $counter = $( '.js-story-carousel-counter' );

		$carousel.on( 'changed.owl.carousel', function( event ) {
			let carousel = event.relatedTarget;

			$counter.text( `${carousel.relative(carousel.current() - 4) + 1} / ${carousel.items().length}` );
		} );

		$carousel.owlCarousel( {
			center: true,
			items: 7,
			dots: false,
			nav: false,
			margin: 20,
			autoWidth: true,
			loop: true,
			autoplay: true,
			autoplayHoverPause: true,
			startPosition: 4,
			responsive: {
				768: {
					margin: 40
				},
				1024: {
					margin: 40
				}
			}
		} );

		$prevButton.on( 'click', function() {
			$carousel.trigger( 'prev.owl.carousel' );
		} );

		$nextButton.on( 'click', function() {
			$carousel.trigger( 'next.owl.carousel' );
		} );

	} );
} )( jQuery );
